export default function snackbar({ variables, }) {
    return {
        MuiSnackbarContent: {
            styleOverrides: {
                root: {
                    backgroundColor: variables.surface_inverse,
                    color: variables.text_inverse,
                    borderRadius: variables.border_radius_small,
                    fontSize: variables.type_body_sm_font_size,
                    boxShadow: variables.box_shadow_medium,
                },
                message: {
                    padding: `${variables.spacing_02} 0`,
                },
            },
        },
    };
}
//# sourceMappingURL=snackbar.js.map